export default __webpack_public_path__ + "static/media/Excel-Logo.8dc9303c.png";